// extracted by mini-css-extract-plugin
export default {"designContainer":"Sniwwoc_designContainer__JEXqh","title":"Sniwwoc_title__J705a"};